import React from 'react';
import ShowDetail from '../Reports/ShowDetail';

// Wide side drawer showing the FULL show record (identical to the Reports →
// Shows detail page). Renders the shared ShowDetail component (which fetches
// /dms/shows/:slug) inside the wide panel.
export default function ShowDrawer({ item, onClose }) {
  const slug = (item && (item.slug || item.uuid || item.identifier)) || '';
  return (
    <div className="ea-root fdrawer fdrawer-wide">
      <div className="bg" onClick={onClose} />
      <div className="panel panel--wide">
        <div className="fhead">
          <div>
            <h2 className="ftitle">Show</h2>
            <p className="fsub">Show record</p>
          </div>
          <button className="fclose" onClick={onClose}>
            ✕ Close
          </button>
        </div>
        {slug ? (
          <ShowDetail name={slug} />
        ) : (
          <div className="fload" style={{ color: 'var(--ea-amber)' }}>
            Show details unavailable.
          </div>
        )}
      </div>
    </div>
  );
}
